"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InfoTooltip = exports.InfoTooltipDefaultProps = void 0;
var react_1 = __importStar(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var utils_1 = require("@shapeable/utils");
var components_1 = require("../../components");
var web_1 = require("@react-spring/web");
var info_circle_icon_1 = require("../../components/icons/info-circle.icon");
var cls = (0, utils_1.classNames)('info-tooltip');
exports.InfoTooltipDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: relative;\n    font-size: ", ";\n  "], ["\n    position: relative;\n    font-size: ", ";\n  "])), theme_1.theme.FONT_SIZE(12))
});
var IconStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    cursor: pointer;\n    margin-right: ", ";\n  "], ["\n    cursor: pointer;\n    margin-right: ", ";\n  "])), theme_1.theme.UNIT(1.5))
});
var TooltipStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    line-height: 1.65em;\n    width: 250px;\n    text-align: left;\n    background: ", ";\n    position: absolute;\n    top: ", ";\n    left: 50%;\n    transform: translateX(-50%);\n    color: ", ";\n    cursor: default;\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);\n\n    * {\n      color: ", ";\n    }\n\n    padding: ", " ", ";\n    border-radius: ", ";\n    z-index: 50;\n  "], ["\n    line-height: 1.65em;\n    width: 250px;\n    text-align: left;\n    background: ", ";\n    position: absolute;\n    top: ", ";\n    left: 50%;\n    transform: translateX(-50%);\n    color: ", ";\n    cursor: default;\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);\n\n    * {\n      color: ", ";\n    }\n\n    padding: ", " ", ";\n    border-radius: ", ";\n    z-index: 50;\n  "])), theme_1.theme.COLOR('dark'), theme_1.theme.UNIT(6), theme_1.theme.COLOR('light'), theme_1.theme.COLOR('light'), theme_1.theme.UNIT(3), theme_1.theme.UNIT(4), theme_1.theme.UNIT(2))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Icon: (0, styled_components_1.default)(components_1.Icon)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), IconStyles),
  Tooltip: (0, styled_components_1.default)(web_1.animated.div)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), TooltipStyles)
};
var InfoTooltip = function (props) {
  var className = props.className,
    message = props.message;
  var _a = __read((0, react_1.useState)(false), 2),
    showTooltip = _a[0],
    setShowTooltip = _a[1];
  var _b = __read((0, react_1.useState)(false), 2),
    isMounted = _b[0],
    setIsMounted = _b[1]; // Controls when tooltip is mounted
  var iconRef = (0, react_1.useRef)(null);
  var tooltipRef = (0, react_1.useRef)(null);
  var hideTimeoutRef = (0, react_1.useRef)(null);
  // Spring animation for the tooltip's fade in/out
  var tooltipSpring = (0, web_1.useSpring)({
    opacity: showTooltip ? 1 : 0,
    config: {
      duration: 200
    },
    // Adjust duration as needed
    onRest: function () {
      if (!showTooltip) setIsMounted(false); // Unmount after fade-out is complete
    }
  });
  // Helper to cancel the hide timeout if needed
  var cancelHideTimeout = function () {
    if (hideTimeoutRef.current) {
      clearTimeout(hideTimeoutRef.current);
      hideTimeoutRef.current = null;
    }
  };
  // Mouse enter for icon and tooltip
  var handleMouseEnter = function () {
    cancelHideTimeout();
    setIsMounted(true); // Ensure tooltip is mounted before showing
    setShowTooltip(true);
  };
  // Mouse leave with a delay before hiding tooltip
  var handleMouseLeave = function () {
    hideTimeoutRef.current = setTimeout(function () {
      setShowTooltip(false);
    }, 400); // 200ms delay before hiding tooltip, adjust as necessary
  };
  (0, react_1.useEffect)(function () {
    var icon = iconRef.current;
    if (icon) {
      icon.addEventListener('mouseenter', handleMouseEnter);
      icon.addEventListener('mouseleave', handleMouseLeave);
    }
    // Cleanup event listeners for icon
    return function () {
      if (icon) {
        icon.removeEventListener('mouseenter', handleMouseEnter);
        icon.removeEventListener('mouseleave', handleMouseLeave);
      }
    };
  }, []);
  // Effect to manage tooltip events after it is mounted
  (0, react_1.useEffect)(function () {
    var tooltip = tooltipRef.current;
    if (tooltip) {
      tooltip.addEventListener('mouseenter', handleMouseEnter); // Cancel hide when mouse enters tooltip
      tooltip.addEventListener('mouseleave', handleMouseLeave); // Trigger hide when mouse leaves tooltip
    }
    // Cleanup tooltip event listeners
    return function () {
      if (tooltip) {
        tooltip.removeEventListener('mouseenter', handleMouseEnter);
        tooltip.removeEventListener('mouseleave', handleMouseLeave);
      }
    };
  }, [isMounted]); // Run this effect only when tooltip is mounted
  if (!message) {
    return null;
  }
  return react_1.default.createElement(My.Container, {
    className: cls.name(className)
  }, react_1.default.createElement(My.Icon, {
    size: 16,
    ref: iconRef
  }, react_1.default.createElement(info_circle_icon_1.InfoCircle, null)), isMounted && react_1.default.createElement(My.Tooltip, {
    ref: tooltipRef,
    style: __assign({}, tooltipSpring)
  }, react_1.default.createElement(components_1.Markdown, {
    text: message
  })));
};
exports.InfoTooltip = InfoTooltip;
exports.InfoTooltip.cls = cls;
exports.InfoTooltip.defaultProps = exports.InfoTooltipDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;